import axios from 'axios'
import { baseURL } from '../../utils/io'

const UPDATE = 'UPDATE_SUBSCRIPTION'
const FETCH = 'FETCH_SUBSCRIPTION'

const INITIAL_STATE = {}

// Reducer

export default (state = INITIAL_STATE, action) => {
  if ([`${UPDATE}_FULFILLED`, `${FETCH}_FULFILLED`].includes(action.type)) {
    const { payload, meta } = action

    return {
      ...state,
      [meta.organizationId]: payload.data,
    }
  }

  return state
}

// Actions

export const saveSubscription = (orgId, data) => ({
  type: UPDATE,
  payload: axios.put(`${baseURL}/organizations/${orgId}/subscription`, data),
  meta: { organizationId: orgId },
})

export const fetchSubscription = orgId => ({
  type: FETCH,
  payload: axios.get(`${baseURL}/organizations/${orgId}/subscription`),
  meta: { organizationId: orgId },
})

export const cancelSubscription = orgId => ({
  type: UPDATE,
  payload: axios.delete(`${baseURL}/organizations/${orgId}/subscription`),
  meta: { organizationId: orgId },
})

// Selectors

export const getSubscription = (state, orgId) => {
  return state.billing[orgId]
}
